<template>
	<v-card class="opaquerBg" rounded>
		<v-card-text>
			<h2 class="text-h4 font-weight-light">Useful Links</h2>

			<v-row no-gutters>
				<v-col>
					<v-list subheader color="transparent">
						<LinkItem
							title="Temporary & Preliminary Updates"
							url="#/updates"
							hideUrl
							icon="mdi-information-outline"
						/>
						<LinkItem
							title="ECDIS Mandate"
							url="#/ecdis"
							hideUrl
							icon="mdi-information-outline"
						/>
						<v-divider />
						<v-subheader inset
							><v-icon left small>mdi-open-in-new</v-icon>Links below opens
							external site</v-subheader
						>
						<LinkItem
							v-for="(item, index) in links"
							:key="index"
							v-bind="item"
							target="_blank"
						/>
					</v-list>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import LinkItem from '@/components/n-collections/n-items/LinkItem'

export default {
	name: 'UsefulLinks',
	components: {
		LinkItem,
	},
	props: {
		links: Array,
	},
}
</script>